module.exports = __webpack_public_path__ + "static/media/DO.414f7969.png";